import React from 'react';
import Text from '@/components/ui/Text';

interface CaptionStatusProps {
  captionEnUrl?: string;
  captionEsUrl?: string;
  needsCaptions?: boolean;
  needsCaptionsEs?: boolean;
}

// AIDEV-NOTE: PLAT-17712 — the state is spelled out rather than shown as a check/cross icon. WCAG
// 2.1 AA is a stated requirement on this story and an icon-only cell announces nothing. This column
// is the practical half of the Spanish requirement: it is where an author sees that a video in the
// reading has no Spanish caption track.
const statusText = (captionUrl?: string, needsCaptions?: boolean) => {
  if (captionUrl) return 'Yes';
  if (needsCaptions) return 'Requested';

  return 'No';
};

const CaptionStatus = ({
  captionEnUrl,
  captionEsUrl,
  needsCaptions,
  needsCaptionsEs,
}: CaptionStatusProps) => (
  <div className="tw-text-very-dark-grey">
    <Text size="sm" tag="div">
      {`English: ${statusText(captionEnUrl, needsCaptions)}`}
    </Text>
    <Text size="sm" tag="div">
      {`Spanish: ${statusText(captionEsUrl, needsCaptionsEs)}`}
    </Text>
  </div>
);

export default CaptionStatus;
